import z from 'zod';

export const promptSchema = z.object({
  system: z.string(),
  user: z.string(),
});

export type Prompt = z.infer<typeof promptSchema>;
